export const baseURL = "https://admin.maalivepartyapp.com/";
export const key = "4cb&r7dea0$nd$*$+*a(a$^x+z";
export const projectName = "Maa Live";